import { DownloadUserTemplateHubService } from './HubServices/DownloadUserTemplateHub.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent  implements OnInit {
  title = 'NedoCloud';
  routerSubscription: any;

  mode=true;
   array = [10, 20, 30];


   public name() {
    this.mode=!this.mode;
   }

  constructor(private router: Router,public signalRService: DownloadUserTemplateHubService) {}

  ngOnInit() {
    this.signalRService.startConnection();
    this.signalRService.addTransferChartDataListener();
  }

}
